import { Component } from '@angular/core';
import { Router } from '@angular/router';
import 'rxjs/add/operator/finally';

import { AuthService } from '../../../services/auth.service';
import { UserService } from '../../../services/user.service';
import { Token } from '../../../entities/index';
import { Log } from '../../../utils/index';

@Component({
  selector: 'app-login',
  templateUrl: './login.html',
  providers: [AuthService]
})
export class LoginComponent {
  email: string;
  password: string;

  loading = false;

  constructor(private authService: AuthService,
              private router: Router,
              private userService: UserService) {
    this.userService.clearCurrentUser();
  }

  @Log('blue')
  onSubmit() {
    this.loading = true;
    this.authService
      .login(this.email, this.password)
      .finally(() => this.loading = false)
      .subscribe(
        (token: Token) => {
          this.authService.authenticate(token);
          this.userService.reloadUser();
          this.router.navigate(['dashboard', 'admin']);
        }
      );
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/pages/login/login.component.ts